'use strict';

const {__} = wp.i18n;

/**
 * Init All Shortcode Admin Side
 */
class TWER_SHORTCODE {

  $shortcode_fullwidth = null;
  $shortcode_disable_zoom = null;

  $shortcode_width = null;
  $shortcode_width_unit = null;

  $shortcode_height = null;
  $shortcode_height_unit = null;

  $shortcode_initial_point_lat = null;
  $shortcode_initial_point_lon = null;

  $shortcode_zoom_level = null;
  $shortcode_zoom_number = null;

  $shortcode_code = null;

  $copyBtn = null;

  shortcodeRawValues = {};

  constructor() {

    // Set all settings fields to variables
    this.$shortcode_fullwidth = document.getElementById('shortcode_fullwidth');
    this.$shortcode_disable_zoom = document.getElementById('shortcode_disable_zoom');

    this.$shortcode_width = document.getElementById('shortcode_width');
    this.$shortcode_width_unit = document.getElementById('shortcode_width_unit');

    this.$shortcode_height = document.getElementById('shortcode_height');
    this.$shortcode_height_unit = document.getElementById('shortcode_height_unit');

    this.$shortcode_initial_point_lat = document.getElementById('shortcode_initial_point_lat');
    this.$shortcode_initial_point_lon = document.getElementById('shortcode_initial_point_lon');

    this.$shortcode_zoom_level = document.getElementById('shortcode_zoom_level');
    this.$shortcode_zoom_number = document.getElementById('shortcode_zoom_number');

    this.$shortcode_code = document.getElementById('shortcode_code');


    // Copy 'Shortcode' button functionality
    this.$copyBtn = document.getElementsByClassName('js-twer-copy-text')[0];
    this.$copyBtn.addEventListener('click', (e) => {

      this.$shortcode_code.select();
      document.execCommand('copy');
    });


    // Sync zoom range input with zoom range number input
    [
      this.$shortcode_zoom_level,
      this.$shortcode_zoom_number
    ].map(($element, index, array) => {
      const currentId = $element.id;
      if (currentId === 'shortcode_zoom_number') {
        if ($element.value === '') {
          this.$shortcode_zoom_level.value = 0;
        } else {
          this.$shortcode_zoom_level.value = $element.value;
        }
      }

      if (currentId === 'shortcode_zoom_level') {
        if (this.$shortcode_zoom_number.value === '') {
          $element.value = 0;
        } else {
          $element.value = this.$shortcode_zoom_number.value;
        }
      }
    });

    // Shortcode settings watch
    [
      this.$shortcode_fullwidth,
      this.$shortcode_disable_zoom,
      this.$shortcode_width,
      this.$shortcode_width_unit,
      this.$shortcode_height,
      this.$shortcode_height_unit,
      this.$shortcode_initial_point_lat,
      this.$shortcode_initial_point_lon,
      this.$shortcode_zoom_level,
      this.$shortcode_zoom_number
    ].map(($element, index, array) => {
      const elementType = $element.type;

      switch (elementType) {
        case 'checkbox' :
          this.shortcodeRawValues[$element.id] = $element.checked;

          $element.addEventListener('change', (e) => {
            this.shortcodeRawValues[e.target.id] = e.target.checked;

            this.makeShortcodeCode();
          });
          break;
        case 'number' :

          this.shortcodeRawValues[$element.id] = $element.value;

          $element.addEventListener('keyup', (e) => {
            if (e.target.id === 'shortcode_zoom_number') {
              if (e.target.value === '') {
                this.$shortcode_zoom_level.value = 0;
                this.shortcodeRawValues.shortcode_zoom_level = 0;
              } else {
                this.$shortcode_zoom_level.value = e.target.value;
                this.shortcodeRawValues.shortcode_zoom_level = e.target.value;
              }
            }

            this.shortcodeRawValues[e.target.id] = e.target.value;

            this.makeShortcodeCode();
          });
          break;
        case 'select-one' :
          this.shortcodeRawValues[$element.id] = $element.value;
          $element.addEventListener('change', (e) => {
            this.shortcodeRawValues[e.target.id] = e.target.value;

            this.makeShortcodeCode();
          });
          break;
        case 'range' :
          this.shortcodeRawValues[$element.id] = $element.value;

          $element.addEventListener('input', (e) => {
            this.$shortcode_zoom_number.value = e.target.value;

            if (e.target.id === 'shortcode_zoom_level') {
              this.shortcodeRawValues.shortcode_zoom_number = e.target.value;
            }


            this.shortcodeRawValues[e.target.id] = e.target.value;

            this.makeShortcodeCode();
          });
          break;
      }

    });

    this.makeShortcodeCode();
  }



  makeShortcodeCode() {
    const shortcodeAtts = new Set();
    const widthUnit = this.shortcodeRawValues.shortcode_width_unit;
    const heightUnit = this.shortcodeRawValues.shortcode_height_unit;

    const width = this.shortcodeRawValues.shortcode_width;
    const height = this.shortcodeRawValues.shortcode_height;

    if(width !== '') {
      this.shortcodeRawValues.shortcode_width = `${parseFloat(width)}${widthUnit}`;
    }

    if(height !== '') {
      this.shortcodeRawValues.shortcode_height = `${parseFloat(height)}${heightUnit}`;
    }

    for (let id in this.shortcodeRawValues) {
      const elementAttr = this.idToShortcodeAttrConverter(id);
      const elementValue = this.shortcodeRawValues[id];
      switch (id) {
        case 'shortcode_fullwidth' :
        case 'shortcode_disable_zoom' :
          if(elementValue) {
            shortcodeAtts.add(elementAttr)
          }
          break;
        case 'shortcode_width' :
        case 'shortcode_height' :
        case 'shortcode_initial_point_lat' :
        case 'shortcode_initial_point_lon' :
        case 'shortcode_zoom_number' :
          if(elementValue !== '') {
            shortcodeAtts.add(elementAttr.replace(/#value#/g, elementValue))
          }
          break;
      }
    }


    const mapId = twer_ajax.post_id;
    let mapAtts = [...shortcodeAtts].join(' ');

    if(mapAtts.trim() !== '') {
      mapAtts = ` ${mapAtts}`;
    }
    this.$shortcode_code.value = `[treweler map-id="${mapId}"${mapAtts}]`;
  }


  idToShortcodeAttrConverter(id) {
    id = id.replace(/shortcode_/g, '');
    let attr = '';
    switch (id) {
      case 'fullwidth' :
        attr = 'type="fullwidth"';
        break;
      case 'disable_zoom' :
        attr = 'scrollzoom="no"';
        break;
      case 'width_unit' :
        attr = 'width-unit="#unit#"';
        break;
      case 'height_unit' :
        attr = 'height-unit="#unit#"';
        break;
      case 'width' :
        attr = 'width="#value#"';
        break;
      case 'height' :
        attr = 'height="#value#"';
        break;
      case 'initial_point_lat' :
        attr = 'lat="#value#"';
        break;
      case 'initial_point_lon' :
        attr = 'lon="#value#"';
        break;
      case 'zoom_number' :
      case 'zoom_level' :
        attr = 'zoom="#value#"';
        break;
    }

    return attr;
  }

}

window.addEventListener('DOMContentLoaded', () => {
  new TWER_SHORTCODE();
});

